import React, { useState } from 'react';
import { useIntl } from 'umi';
import { notification } from 'tea-component';
import { IDomEditor } from '@wangeditor/editor';
import EditModal from '@home/pages/studio/opinions/components/EditModal';
import { InsightsData } from '../../type';
import { saveModuleContent } from '@home/services/studio';
interface IProps {
  className: string;
  style: React.CSSProperties;
  showModal: boolean;
  setShowModal:(boolean: boolean)=>void;
  insightsData: InsightsData;
  filter: any;
  gameInfo?: any;
  getInsightsData: () => void;
  editModalTitle: string;
}

export default function InsightsEdit(props: IProps) {
  const { className, style, insightsData, filter, gameInfo, showModal, setShowModal, getInsightsData, editModalTitle } = props || {};
  const { formatMessage } = useIntl();
  const { date_type: dateType, start_time: startTime, end_time: endTime, game} = filter || {};
  const [editLoading, setEditLoading] = useState<boolean>(false);

  // 确认按钮点击事件，编辑保存Insights内容
  const handleSubmit = (data: string) => {
    setEditLoading(true);
    const params = {
      module_contents: [{
        id: insightsData?.id,
        system: "studio_hub",
        type: 2,
        uid_type: "unified_id,comp_unified_id",
        uid: `${gameInfo?.edition_unified_id},${game}`,
        user_id: "",
        period: dateType,
        start_time: startTime,
        end_time: endTime,
        module: "insights",
        content: data,
        status: 1,
      }]
    };
    saveModuleContent?.(params).then(() => {
      setEditLoading(false);
      notification.success({
        description: formatMessage({id: 'dbh_studio_funcom_edit_modal_success'}),
        duration: 1000,
      });
      setShowModal(false);
      getInsightsData();
    }).catch(() => {
      setEditLoading(false);
      notification.error({
        description: formatMessage({id: 'dbh_studio_funcom_edit_modal_failed'}),
        duration: 1000,
      });
    });

  };

  const changeShowModal = () => {
    setShowModal(!showModal);
  };
  // 忽略图片粘贴
  const customPaste = (editor: IDomEditor, e: ClipboardEvent) => {
    const { clipboardData } = e;
    if (!clipboardData) return true;
  
    return ![...clipboardData.items, ...clipboardData.files].some(item => item.type.startsWith('image/'));
  };
  
  return (
    <div className={className} style={style}>
      <EditModal
        title={editModalTitle}
        closeModal={changeShowModal}
        isVisible={showModal}
        customPaste={customPaste}
        data={insightsData?.content}
        handleSubmit={handleSubmit}
        handleCancel={showModal}
        handelCancel={changeShowModal}
        loading={editLoading}
        // 解决重新打开modal编辑器报错问题，editor未实例化
        destroyOnClose={false}
      />
    </div>
  );
}
